<template>
  <div class="header__dropdown-container">
    <div class="header__dropdown-container-inner">
      <div class="header__dropdown-inner-small-images-container">
        <div class="header__dropdown-image-outer-container" v-if="block.image_1"><a class="header__dropdown-image-outer-content-container clip-transition" v-if="block.image_1_url" :href="block.image_1_url">
            <div class="header__dropdown-image-container"><img class="header__dropdown-image" :src="block.image_1" :alt="block.image_1_text"/></div>
            <div class="header-menu-image-title link link--primary" v-if="block.image_1_text">{{ block.image_1_text }}
            </div></a>
          <div class="header__dropdown-image-outer-content-container clip-transition" v-else>
            <div class="header__dropdown-image-container"><img class="header__dropdown-image" :src="block.image_1" :alt="block.image_1_text"/></div>
            <p class="header-menu-image-title" v-if="block.image_1_text">{{ block.image_1_text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'NavbarDesktopSmallImageBlocks',
  components: { Icon },
  props: {
    block: Object
  }
}
</script>

<style scoped lang="scss">
  .header__dropdown-container-inner {
    display: flex;
    flex-direction: column;
    width: 100%;

    @include desktop-up {
      flex-direction: row;
      justify-content: space-between;
      max-width: $container-max-width;
      margin-left: auto;
      margin-right: auto;
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  .header-menu-image-title {
    padding-right: 5px;
    margin: 0;
    margin-top: 16px;
    display: flex;
    align-items: center;
    color: $color-brand-primary;
    display: inline-block;
    font-weight: 400;

    &:hover {

      &::before {
        background-color: $color-brand-primary;
      }
    }

    &:before {
      background-color: $color-brand-primary;
    }
  }

  .header__dropdown-inner-small-images-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .header__dropdown-image-outer-container {
    margin-right: 32px;
    max-width: 290px;
  }

  .header__dropdown-image-outer-container:last-child {
    padding-left: 100px;
    margin-right: 0;
  }

  .header-menu-image-title svg {
    fill: $color-brand-primary;
  }

</style>
